import { render, staticRenderFns } from "./NavigationSectionDefault.vue?vue&type=template&id=8239e6b4&"
import script from "./NavigationSectionDefault.vue?vue&type=script&lang=ts&"
export * from "./NavigationSectionDefault.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports